// Mirrors qerchabackend/utils/passwordPolicy.js for instant feedback, including the common-password list.
import { COMMON_PASSWORDS } from './commonPasswords';

export const MIN_CHARS = 8;
export const MAX_CHARS = 100;
export const BCRYPT_MAX_BYTES = 72;

const isRepeatedCharacter = (value) => /^(.)\1*$/u.test(value);

// Returns a user-facing error message, or null when the password passes the local checks
export function validatePassword(password) {
  if (!password) return 'Password is required.';
  const length = [...password].length;
  if (length < MIN_CHARS) return `Password must be at least ${MIN_CHARS} characters.`;
  if (length > MAX_CHARS) return `Password must be ${MAX_CHARS} characters or fewer.`;
  if (new TextEncoder().encode(password).length > BCRYPT_MAX_BYTES) {
    return 'Your password is too long. Please shorten it and try again.';
  }
  if (COMMON_PASSWORDS.has(password.toLowerCase()) || isRepeatedCharacter(password)) return 'This password is too common or easily guessed. Choose a different one.';
  return null;
}

// 'weak' | 'medium' | 'strong'
export function passwordStrength(password) {
  if (validatePassword(password)) return 'weak';
  const classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].filter((re) => re.test(password)).length;
  const length = [...password].length;
  if (length >= 14 || (length >= 10 && classes >= 3)) return 'strong';
  return 'medium';
}

// Translation key for each message validatePassword returns (English text is the fallback)
const MESSAGE_KEYS = {
  'Password is required.': 'password.required',
  [`Password must be at least ${MIN_CHARS} characters.`]: 'password.tooShort',
  [`Password must be ${MAX_CHARS} characters or fewer.`]: 'password.maxLength',
  'Your password is too long. Please shorten it and try again.': 'password.tooLong',
  'This password is too common or easily guessed. Choose a different one.': 'password.common',
};

// Shows a validation message in the current language; unknown messages are returned unchanged
export function translatedProblem(t, message) {
  const key = MESSAGE_KEYS[message];
  return key ? t(key) : message;
}
